export enum GroupType {
    Sub = "sub",
    Root = "root",
    License = "license",
}

export enum ActiveTabKey {
    Groups = "groups",
    Users = "users",
}
/**
 * Query keys.
 */
export enum QueryKeys {
    GroupsList = "GroupsList",
    UserGroupCurrent = "UserGroupCurrent",
    GroupUsers = "GroupUsers",
    Users = "Users",
    UserGroupCredits = "UserGroupCredits",
    UserRoles = "UserRoles",
    UserCredits = "UserCredits",
}

export enum Role {
    SystemAdmin = "System Admin",
    SystemManager = "System Manager",
    ClientAdmin = "Client Admin",
    ClientManager = "Client Manager",
    ClientUser = "Client User",
    StandardUser = "Standard User",
    GuestUser = "Guest User",
}

// Define color schemes for each tag type
export const tagColors = {
    [Role.SystemAdmin]: "#ffd4d4",
    [Role.SystemManager]: "#b7faa9",
    [Role.ClientAdmin]: "#AFE7FF",
    [Role.ClientManager]: "#E5B9FF",
    [Role.ClientUser]: "#92A8C6",
    [Role.StandardUser]: "#BAC6FF",
    [Role.GuestUser]: "#DFE0E1",
};
